


























import { defineComponent, ref, watch } from '@vue/composition-api';

import { useSelectable } from 'vivat';
import getAllTags from '@/gql/getAllTags.gql';
import { useQuery, useResult } from '@vue/apollo-composable';

const TAG_GROUPS = {
  type: { name: 'Material' },
  content: { name: 'Content' },
  style: { name: 'Style' },
  design: { name: 'UI/UX Design' },
  nostalgia: { name: 'Nostalgia' },
  format: { name: 'ฟอร์แมตของไฟล์งาน' },
};

const PanelWithTagsEditor = defineComponent({
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  setup(props, context) {
    const { result: getAllTagsResult } = useQuery(getAllTags);
    const tags = useResult(getAllTagsResult, [], (data: any) => data.tagGroups);

    function getTags(group: string) {
      return (tags.value.find((tagGroup: any) => tagGroup.slug === group) || { tags: [] }).tags;
    }

    const {
      selectedItems: selectedList,
      onSelect: onSelectList,
      isSelected: isSelectedList,
    } = useSelectable(props.value, (elm: any) => elm.name);

    watch(() => props.value, () => {
      selectedList.value = props.value;
    });

    function onSelect(items: any, setTo: any) {
      onSelectList(items, setTo);
      context.emit('input', selectedList.value);
    }

    const helperFilter = ref('');

    return {
      helperFilter,
      tags,
      getTags,
      onSelect,
      isSelectedList,
      tagGroup: TAG_GROUPS,
      arrangement: Object.keys(TAG_GROUPS),
    };
  },
});

export default PanelWithTagsEditor;
